import type { FaireAdvertiserProfileEntity } from "../../entity_types/advertiserProfile";

// Penguin Random House (b_q68qsrd57c, advertiser 168700553828280412).
// Real numbers from ANALYTICS.ADS.CAMPAIGN_PERIODS (complete months
// Oct 2024 – Sep 2025). NEW_ONLY; the campaign was STOPPED on 2025-10-14, so this
// is a paused advertiser with history. Monthly series lives in realBrandData.ts.
export const advPenguinRandomHouse: FaireAdvertiserProfileEntity = {
  token: "adv_penguin_rh",
  type: "advertiserProfile",
  archetype: "churned-with-history",
  displayName: "Penguin Random House",
  brandToken: "b_q68qsrd57c",
  audienceType: "NEW_ONLY",
  globalStatus: "STOPPED",
  tenureMonths: 12,
  budget: {
    totalBudgetDollars: 500,
    spendingMode: "CONSERVATIVE",
  },
  overview: {
    numCustomersAcquired: 130,
    numReorderConversions: 0,
    numTotalConversions: 130,
    totalAdsSalesDollars: 72258,
    newCustomerAdsSalesDollars: 72258,
    reorderAdsSalesDollars: 0,
    totalAdsSpendDollars: 5639,
    newCustomerAdsSpendDollars: 5639,
    reorderAdsSpendDollars: 0,
    newCustomerBestEstimateFirstYearRoas: 12.81,
    reorderRoas: 0,
    combinedFirstYearRoas: 12.81,
  },
  availableCredit: {
    totalRemainingDollars: 0,
  },
  budgetRecommendations: {
    newCustomer: {
      minRecommendedBudgetDollars: 500,
      maxRecommendedBudgetDollars: 1500,
    },
  },
  campaignTokens: ["camp_prh_new"],
  overviewPerformancePeriodTokens: [],
  meta: {
    source: "snowflake",
    importedAt: "2026-07-20T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
